import { render } from "./MessageTemplateForm.vue?vue&type=template&id=c7c0c5bc&scoped=true"
import script from "./MessageTemplateForm.vue?vue&type=script&lang=js"
export * from "./MessageTemplateForm.vue?vue&type=script&lang=js"

import "./MessageTemplateForm.vue?vue&type=style&index=0&id=c7c0c5bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c0c5bc"]])

export default __exports__